import { User } from 'types'

export const hasCompleteProfile = (user: User): boolean => {
  return !!user.firstName && !!user.lastName
}
